import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Button, SvgIcon, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import useCurrentUser from 'src/hooks/use-current-user';
import { paths } from 'src/paths';
import { resetNewDocumentSignAction } from 'src/redux/actions/documentationAction';
import { getAccessToken } from 'src/routes/AuthContext';
import { BootstrapDialog } from '../common-modals/BootstrapDialog';
import SignDocementModel from './signature-document-popup';

function SignatureTemplatePreviewNew() {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { document } = location?.state;
  // const [keys, setKeys] = useState({
  //   documentId: '',
  //   embedKey: '',
  // });
  const { patients, patientDetails, episodeOfCare, details } = paths;
  // const signatureTemplateResponse = useSelector((state: any) => state.getSignatureTemplateReducer);
  const getPatientId = useSelector((state: any) => state?.getPatientIdReducer);
  const [providerId] = useCurrentUser(['providerId']);
  const [iframeRef, setIframeRef] = useState<any | null>(null);

  const [openNewSignModel, setOpenNewSignModel] = useState(false);
  const [isDocSigned, setIsDocSigned] = useState({
    isSuccessful: false,
    pdfUrl: '',
  });

  const updateIFrameRef = useCallback((node: any) => {
    setIframeRef(node);
  }, []);

  useEffect(() => {
    const iframeElement = iframeRef;

    if (iframeElement) {
      const interval = setInterval(async () => {
        const response = await getAccessToken();
      }, 15000);

      return () => {
        clearInterval(interval);
      };
    }
  }, [iframeRef]);

  // useEffect(() => {
  //   dispatch(
  //     getSignatureTemplate({
  //       formSubmissionId: document.uuid,
  //       isSupervisor: document.supervisorId === providerId ? true : false,
  //     })
  //   );
  // }, []);

  // useEffect(() => {
  //   if (
  //     !signatureTemplateResponse.isGetSignatureTemplate &&
  //     signatureTemplateResponse.response === null
  //   )
  //     return;
  //   setKeys({
  //     documentId: signatureTemplateResponse.response?.documentId,
  //     embedKey: signatureTemplateResponse.response?.embedKey,
  //   });
  // }, [signatureTemplateResponse]);

  const goBackToEOC = () => {
    navigate(`${patients}/${patientDetails}${episodeOfCare}${details}`, {
      state: {
        episodeOfCareId: location?.state?.episodeOfCareId,
        getPatientId,
      },
    });
  };

  const handleOpenNewSignModel = () => {
    if (isDocSigned.isSuccessful) {
      navigate(`${patients}/${patientDetails}${episodeOfCare}${details}`, {
        state: {
          episodeOfCareId: location?.state?.episodeOfCareId,
          getPatientId,
        },
      });
    } else {
      dispatch(resetNewDocumentSignAction());
      setOpenNewSignModel(true);
    }
  };

  const handleCloseNewSignModel = () => {
    setOpenNewSignModel(false);
    dispatch(resetNewDocumentSignAction());
  };

  // const handleSignConfirm = useCallback(async (signatureName: string) => {
  //   dispatch(
  //     getSignatureTemplate({
  //       formSubmissionId: document.uuid,
  //       isSupervisor: document.supervisorId === providerId ? true : false,
  //     })
  //   );
  // }, []);

  return (
    <>
      <Stack
        gap="1.5rem"
        sx={{ padding: '0 4rem' }}
      >
        <Button
          sx={{
            justifyContent: 'flex-start',
            color: '#111927',
            width: 'max-content',
            padding: '0px',
          }}
          startIcon={
            <SvgIcon>
              <ArrowBackIcon sx={{ color: '#6C737F' }} />
            </SvgIcon>
          }
          onClick={goBackToEOC}
        >
          <Typography variant="subtitle1">
            Back to Episode Of Care Details -
            {` ${location?.state?.patientData?.lastName ?? ''} ${
              location?.state?.patientData?.firstName ?? ''
            }`}
          </Typography>
        </Button>
        <Stack
          flexDirection="row"
          gap="1rem"
          alignItems="center"
          justifyContent={'space-between'}
        >
          <Typography variant="h5">
            Preview Document - {location?.state?.document?.documentType}
          </Typography>
          <Button
            variant="contained"
            onClick={handleOpenNewSignModel}
          >
            {isDocSigned.isSuccessful ? 'Submit' : 'Start signing'}
          </Button>
        </Stack>
      </Stack>
      <Box
        sx={{ height: '100%' }}
        p={3}
      >
        <iframe
          src={
            isDocSigned.isSuccessful ? isDocSigned.pdfUrl : `${location?.state?.document?.pdfUrl}`
          }
          ref={updateIFrameRef}
          width={'100%'}
          height={'100%'}
          style={{ border: 'none' }}
          title='Documents'
        />
      </Box>

      <BootstrapDialog
        PaperProps={{ style: { width: '600px' } }}
        onClose={handleCloseNewSignModel}
        aria-labelledby="customized-dialog-title"
        open={openNewSignModel}
      >
        <SignDocementModel
          onClose={handleCloseNewSignModel}
          setIsDocSigned={setIsDocSigned}
          formSubmissionUuid={document?.uuid}
          isSupervisor={providerId === document.supervisorId}
          docType={document?.formType}
          open
        />
      </BootstrapDialog>
    </>
  );
}

export default SignatureTemplatePreviewNew;
